
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function PageTransition() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setIsLoading(true);
    setProgress(0);

    // Animate progress bar
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) {
          clearInterval(progressInterval);
          return 90;
        }
        return prev + Math.random() * 15;
      });
    }, 50);

    // Complete the animation
    const completeTimer = setTimeout(() => {
      setProgress(100);
      setTimeout(() => {
        setIsLoading(false);
        setProgress(0);
      }, 300);
    }, 400);

    return () => {
      clearInterval(progressInterval);
      clearTimeout(completeTimer);
    };
  }, [location.pathname]);

  if (!isLoading && progress === 0) return null;

  return (
    <>
      {/* Top Progress Bar */}
      <div className="fixed top-0 left-0 right-0 z-[100] h-1 bg-transparent">
        <div
          className="h-full bg-gradient-to-r from-teal-400 via-teal-500 to-navy transition-all duration-200 ease-out"
          style={{ width: `${progress}%` }}
        >
          <div className="absolute right-0 top-0 h-full w-24 bg-gradient-to-r from-transparent to-white/30 animate-pulse"></div>
        </div>
      </div>

      {/* Overlay with Logo Animation */}
      <div
        className={`fixed inset-0 z-[99] flex items-center justify-center pointer-events-none transition-opacity duration-300 ${
          progress < 100 ? 'opacity-100' : 'opacity-0'
        }`}
      >
        {/* Subtle backdrop */}
        <div className="absolute inset-0 bg-white/80 backdrop-blur-sm"></div>
        
        {/* Animated Logo/Loader */}
        <div className="relative flex flex-col items-center">
          {/* Spinning ring */}
          <div className="relative w-16 h-16">
            <div className="absolute inset-0 rounded-full border-4 border-slate-200"></div>
            <div 
              className="absolute inset-0 rounded-full border-4 border-transparent border-t-navy border-r-teal-500 animate-spin"
              style={{ animationDuration: '0.8s' }}
            ></div>
            
            {/* Center icon */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-pulse-line text-2xl text-navy animate-pulse"></i>
              </div>
            </div>
          </div>

          {/* Loading text */}
          <div className="mt-4 flex items-center space-x-1">
            <span className="text-sm font-medium text-navy/70 tracking-wide">Loading</span>
            <span className="flex space-x-0.5">
              <span className="w-1 h-1 bg-navy/50 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
              <span className="w-1 h-1 bg-navy/50 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
              <span className="w-1 h-1 bg-navy/50 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
